import LabeledSelect from "../../../components/selects/LabeledSelect";

const UnitSelector = ({onChange, selectedUnit}) => {
  return <LabeledSelect
    label="Unit"
    options={unit}
    onChange={onChange}
    value={unit.find((u) => u.value === selectedUnit)}
  />
}

export default UnitSelector;

export const unit = [
  {
    value: "kgs",
    label: "kgs"
  },
  // {
  //   value: "gm",
  //   label: "gm"
  // }
]
